import Vue from 'vue'
import VueCtkCarousel from 'vue-ctk-carousel'

Vue.use(VueCtkCarousel)
